import { useMutation } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";

export function useProductDelete() {
    const query = useMutation({
        mutationFn: async (id: number) => {
            const response = await loggedInApiCall.delete("/api/products/" + id);
            return response;
        },
    });

    return query;
}
